import React from 'react';
import { Avatar, Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { t } from 'i18next';
import { Platform } from '../GamesList/platform';
import { CartridgeSymbol } from '../CartridgeSymbol/cartridgeSymbol';
import { ActionCopyId } from '../../utils/icons/actionCopyId';
import { trimAddress } from '../../utils/parser';
import { Color } from 'src/theme/color';
import { getTransparent } from '../../utils/themer';

export const AvatarPanel = ({
	name,
	ico,
	account,
	handleInfo = () => {},
	maxW,
	maxH,
	game,
}: {
	name: string;
	ico: any;
	account?: string;
	handleInfo?: () => void;
	maxW?: any;
	maxH?: any;
	game?: {
		platforms: string[];
		tag: string;
		cartridgeType: string;
	};
}) => {
	return (
		<Flex alignItems="center">
			<Avatar
				maxW={maxW}
				maxH={maxH}
				borderRadius="5px"
				name={name.slice(0, 1)}
				src={ico}
				onClick={handleInfo}
				cursor="pointer"
				background="none"
				userSelect="none"
			/>
			{account && (
				<Flex
					fontSize="12px"
					ml="14px"
					flexDirection="column"
					gridGap="4px"
					lineHeight="15px"
				>
					<Flex
						alignItems="center"
						gridGap="8px"
					>
						<Tooltip
							placement="bottom-end"
							label={name}
						>
							<Text
								textOverflow="ellipsis"
								whiteSpace="nowrap"
								overflow="hidden"
								display="block"
								maxW="102px"
								onClick={handleInfo}
								cursor="pointer"
								fontWeight="600"
							>
								{name}
							</Text>
						</Tooltip>
						{game && (
							<CartridgeSymbol
								symbol={game.tag}
								type={game.cartridgeType}
								color="white"
							/>
						)}
					</Flex>
					<Flex
						alignItems="center"
						gridGap="8px"
					>
						<CopyToClipboard text={account}>
							<Box
								color={getTransparent(Color.TEXT, 50)}
								cursor="pointer"
							>
								<Tooltip
									placement="bottom-end"
									label={t('default.copyAddress').toString()}
								>
									<Flex
										alignItems="center"
										gridGap="4px"
									>
										<Text>{trimAddress(account)}</Text>
										<ActionCopyId />
									</Flex>
								</Tooltip>
							</Box>
						</CopyToClipboard>
						{game && (
							<Platform
								isGray
								data={game.platforms}
							/>
						)}
					</Flex>
				</Flex>
			)}
		</Flex>
	);
};
